// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test[data-v-22e51ee8]{min-height:100vh}.payment[data-v-22e51ee8]{border-top:1px solid #ccc}.payment .item[data-v-22e51ee8]{border-bottom:1px solid #ccc;padding-top:1rem;padding-bottom:1rem}", ""]);
// Exports
module.exports = exports;
